import { Stack, useMediaQuery } from '@mui/material';
import SponaInNumbers from '../../../components/public-screen-components/SponaInNumbers';
import Opinions from './components/Opinions';
import OurBenefits from './components/OurBenefits';
import OurPeople from './components/OurPeople';
import WorkWithUsHero from './components/WorkWithUsHero';
import { LAYOUT_DEFAULTS } from '../../../utils/constants';
import theme from '../../../utils/theme';
import MetaTags from '../../../components/seo/MetaTags';
import OpenPositions from './components/OpenPositions/OpenPositions';

const metaTags = {
  description: `Interested in working at Spona? Here's where to find out what it's like to work at Spona and learn about new job openings.`,
};
const sponaInNumbersContent: { value: string; title: string }[] = [
  {
    value: '9K+',
    title: 'Digital service providers',
  },
  {
    value: '4K+',
    title: 'Businesses hiring digital service providers',
  },
  {
    value: '133+',
    title: 'Countries where we operate',
  },
  {
    value: '40+',
    title: 'Digital services offered',
  },
];

const WorkWithUs = () => {
  const isLessThanMedium = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <MetaTags {...metaTags} />
      <Stack overflow="hidden" width="100%">
        <WorkWithUsHero sponaInNumbersContent={sponaInNumbersContent} />

        {isLessThanMedium && (
          <SponaInNumbers
            content={sponaInNumbersContent}
            sx={{
              height: 'auto',
              mb: { xs: 14 },
              ...LAYOUT_DEFAULTS,
            }}
          />
        )}

        <OurBenefits />

        <OpenPositions />

        <OurPeople />

        <Opinions />
      </Stack>
    </>
  );
};
export default WorkWithUs;
